// extracted by mini-css-extract-plugin
export default {"root":"TNpl8c","disabled":"xQgj5A"};